import reportUnlockReducer from "./reportUnlockReducer";

const reportUnlockReducers = {
    reportUnlock: reportUnlockReducer
};

export default reportUnlockReducers;